import { AlertCircle, LoaderCircle, X } from "lucide-react";
import { useAppStore } from "../state/appStore";
import { IconButton } from "../components/ui";

export function ProcessingScreen({ onCancel, onRetry }: { onCancel: () => void; onRetry: () => void }) {
  const { processing, processingError } = useAppStore();
  const ratio = Math.round((processing?.ratio ?? 0) * 100);
  return <main className="screen processing-screen">
    <header className="app-header"><span /><h1>识别图纸</h1><IconButton label="取消" onClick={onCancel}><X /></IconButton></header>
    <section className="processing-body">
      {processingError ? <>
        <div className="process-icon error"><AlertCircle /></div>
        <h2>暂时无法完成识别</h2><p>{processingError}</p>
        <button className="primary" onClick={onRetry}>重新识别</button>
        <button className="text-button" onClick={onCancel}>返回重新选择</button>
      </> : <>
        <div className="process-icon"><LoaderCircle className="spin" /></div>
        <h2>{processing?.stage ?? "准备图片"}</h2>
        <p>{processing?.detail ?? "正在读取图片，请不要锁屏。"}</p>
        <div className="large-progress"><span style={{ width: `${ratio}%` }} /></div><strong>{ratio}%</strong>
        <button className="text-button" onClick={onCancel}>取消识别</button>
      </>}
    </section>
  </main>;
}
